import { render, staticRenderFns } from "./addRecedeGoods.vue?vue&type=template&id=99182d04&scoped=true&"
import script from "./addRecedeGoods.vue?vue&type=script&lang=js&"
export * from "./addRecedeGoods.vue?vue&type=script&lang=js&"
import style0 from "./addRecedeGoods.vue?vue&type=style&index=0&id=99182d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99182d04",
  null
  
)

export default component.exports